module.exports = __webpack_public_path__ + "static/media/mentoralas-folyamat.3d9aa552.png";